<style lang="scss" scoped>
.error-msg {
    display: flex;
    .error-icn {
        width: 20px;
        height: 20px;
        background: var(--danger);
        color: #fff;
        display: block;
        border-radius: 3px;
        text-align: center;
        line-height: 20px;
        flex: none;
    }
    .error-txt {
        font-weight:  700;
        color: var(--danger);
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>

<template>
    <div>
        <template v-if="error && typeof error === 'string'">
            <transition name="fade">
                <div class="error-msg d-flex flex-none small">
                    <span class="error-icn my-auto mr-16">!</span>
                    <div class="error-txt my-auto">{{ translate ? $t(`errors.${error}`) : error }}</div>
                </div>
            </transition>
        </template>
        <template v-else-if="error && typeof error === 'object'">
            <transition-group name="fade">
                <div v-for="(e, i) in error" :key="`${i}_error`" class="error-msg d-flex flex-none small mb-8">
                    <span class="error-icn my-auto mr-16">!</span>
                    <div class="error-txt my-auto">{{ translate ? $t(`errors.${e}`, { 0: $t(`form-elements.${i}`) }) : e }}</div>
                </div>
            </transition-group>
        </template>
    </div>
</template>

<script>
export default {
    name: 'el-error',

    props: {
        error: {
            default: false,
        },
        translate: {
            type: Boolean,
            default: true,
        }
    },
};
</script>
